// extracted by mini-css-extract-plugin
module.exports = {"container":"_3a494aec","message":"_51a137e0","countdown":"_b2eb5e5a","onHold":"_7b12d525","sold":"_71e3d4df"};